import React from "react";

const DenyAccess = () => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        gap: "8px",
        width: "100%",
        height: "100%",
      }}>
      <img
        alt="no_access"
        src="/assets/images/svg/alertWarning.svg"
        style={{ width: "100px", height: "100px" }}
      />
      <p style={{ fontSize: "24px" }}>لا يوجد لك صلاحية لزيارة هذه الصفحة</p>
    </div>
  );
};

export default DenyAccess;
